<div class="section__header">
  <h2 class="section__header-text">Instrument Procedures</h2>
  <div *ngIf="sortedProcedures.length > 0" class="section__header-actions">
    <button mat-button (click)="toggleAll()" color="primary" class="procedure-listing__toggle-all">
      <ng-container *ngIf="allSelected">Clear All</ng-container>
      <ng-container *ngIf="!allSelected">Select All</ng-container>
    </button>
  </div>
</div>
<div *ngIf="hasProcs; else placeholder" class="section-body">
  <div class="procedure-listing__subheader">
    <span class="procedure-listing__cycle-label">Data Cycle:</span>
    <div class="procedure-listing__cycle">
      <mat-button-toggle-group [(ngModel)]="cycle" class="procedure-listing__cycle-btn-group">
        <mat-button-toggle [value]="TerminalProcedureCycle.Current">Current</mat-button-toggle>
        <mat-button-toggle [value]="TerminalProcedureCycle.Next">Upcoming</mat-button-toggle>
      </mat-button-toggle-group>
      <span *ngIf="effDateFrom && effDateTo" class="procedure-listing__cycle-eff-date">
        Effective: {{ effDateFrom | date: 'shortDate' }} - {{ effDateTo | date: 'shortDate' }}
      </span>
    </div>
    <div *ngIf="allProcedures.length > 0" class="procedure-listing__filters">
      <mat-checkbox [disabled]="!anyChanged" [(ngModel)]="changedOnly" [matTooltip]="changedOnlyTooltip"
                    class="procedure-listing__chk">
        Changed only
      </mat-checkbox>
      <mat-checkbox [disabled]="!anyDeleted" [(ngModel)]="hideDeleted" [matTooltip]="hideDeletedTooltip"
                    class="procedure-listing__chk">
        Hide deleted
      </mat-checkbox>
    </div>
  </div>
  <div *ngIf="sortedProcedures.length > 0; else cyclePlaceholder" class="procedure-listing__body">
    <app-procedure #procedureComponent *ngFor="let procedure of sortedProcedures" [procedure]="procedure"
                   class="procedure-listing__procedure"
                   [class.procedure-listing__procedure--selected]="procedureComponent.selected">
    </app-procedure>
  </div>
</div>
<div *ngIf="sortedProcedures.length > 0" class="section__footer procedure-listing__footer">
  <div class="procedure-listing__download-label">
    Download Selected<ng-container *ngIf="selectedProcedures.length > 0"> ({{ selectedProcedures.length }})</ng-container>:
  </div>
  <div class="procedure-listing__download-buttons">
    <div class="procedure-listing__btn-wrapper" [matTooltip]="downloadTooltip">
      <button mat-button (click)="download(TerminalProcedureBatchFormat.PDF)" class="aopa-mat-btn aopa-mat-btn--outlined"
              [disabled]="downloadDisabled">
        <mat-icon fontSet="fa" fontIcon="fa-file-pdf-o" class="aopa-mat-btn__icon procedure-listing__btn-icon"></mat-icon>
        <span class="aopa-mat-btn__text">Single PDF</span>
      </button>
    </div>
    <span class="procedure-listing__download-sep">or</span>
    <div class="procedure-listing__btn-wrapper" [matTooltip]="downloadTooltip">
      <button mat-button (click)="download(TerminalProcedureBatchFormat.ZIP)" class="aopa-mat-btn" [disabled]="downloadDisabled">
        <mat-icon fontSet="fa" fontIcon="fa-file-zip-o" class="aopa-mat-btn__icon procedure-listing__btn-icon"></mat-icon>
        <span class="aopa-mat-btn__text">ZIP File</span>
      </button>
    </div>
  </div>
  <div class="procedure-listing__disclaimer">
    Use subject to <a href="https://aopa.org/travel/us-terminal-procedures" target="_blank">Terms and Conditions</a>
  </div>
</div>
<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">There are no instrument procedures available at {{identifier}}.</div>
  </div>
</ng-template>
<ng-template #cyclePlaceholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">
      {{ placeholderMessage }}
    </div>
  </div>
</ng-template>
